import { AIAssistantReviewSurvey, ApplicantIdentities, ApplicantPortalPage, Block, Collection, CustomBarChart, CustomNumber, CustomPieChart, Dashboard, DashboardComponent, ExpandedSurvey, GiveCardMailing, Macro, NotificationGroup, Payment, QualtricsResponseHandler, Report, Root, Subsurvey, Table, TopLevelTemplatedBlock, USBankCardMailing, UsioMailing, ThirdPartyCheck } from "@aidkitorg/types/lib/survey";
import { expandTemplatesStrict } from "@aidkitorg/types/lib/translation/v0_to_legacy";

export type SearchableComponent =
  Block
  | Collection
  | NotificationGroup
  | TopLevelTemplatedBlock
  | Payment
  | Dashboard
  | Report
  | DashboardComponent
  | UsioMailing
  | GiveCardMailing
  | USBankCardMailing
  | ApplicantIdentities
  | QualtricsResponseHandler
  | Macro
  | ApplicantPortalPage
  | Table
  | CustomNumber
  | CustomBarChart
  | CustomPieChart
  | AIAssistantReviewSurvey
  | ThirdPartyCheck['type'];

export default function enumerateSubsurveys(root: Root): Subsurvey[] {
  let expanded = expandTemplatesStrict(root)
  if (!expanded) return [];

  function traverse(block: SearchableComponent): Subsurvey[] {
    if (block.kind == 'Subsurvey') {
      return [block, ...block.sections.flatMap(traverse)];
    }
    if (block.kind == 'Section') {
      return block.components.flatMap(traverse);
    }
    if (block.kind == 'Collection') {
      return block.components.flatMap(traverse);
    }
    return [];
  }
  const subsurveys = (Array.isArray(expanded) ? expanded : expanded.survey).flatMap(traverse);
  return subsurveys;
}
